import React from 'react';
import moment from 'moment';
import formats from '../../../../const/formats';
import withClickOutsideOnOverlay from '../../../../hoc/withClickOutsideOnOverlay';
import history from '../../../../history';
import PopupWrapper from '../../../components/Popup/PopupWrapper';
import PopupBody from '../../../components/Popup/PopupBody';
import PopupHeader from '../../../components/Popup/PopupHeader';
import PopupButtons from '../../../components/Popup/PopupButtons';
import PopupButton from '../../../components/Popup/PopupButton';
import PopupCancelButton from '../../../components/Popup/PopupCancelButton';
import { routeInfo } from '../../../../routeInfo';
class AccountHasNotVerifiedPopup extends React.Component {
    reRegister = () => {
        const {
            email,
            onClose
        } = this.props;
        onClose();
        history.replace(routeInfo.registerWithEmail(email));
    }

    render() {
        const {
            email,
            subject,
            lastTs,
            onClose
        } = this.props;

        const date = moment(+lastTs).format(formats.MM_DD_YY_hh_mm_a);

        return <PopupWrapper className="account-has-not-verified-popup">
            <PopupHeader
                title="Email verification"
                titleIcon="icon-alan-email"
                onCancel={onClose} />
            <PopupBody>
                <div>
                    Your email <b>{email}</b> has not been verified yet.
                    <br /><br />
                    Last confirmation email has been sent on <b>{date}</b> with subject <b>“{subject}”</b>.
                    <br /><br />
                    Please check your mail and confirm an email address.
                </div>
                <PopupButtons>
                    <PopupCancelButton label="Close" action={onClose} />
                    <PopupButton label="Register again" action={this.reRegister} />
                </PopupButtons>
            </PopupBody>
        </PopupWrapper>;
    }
}

export default withClickOutsideOnOverlay(AccountHasNotVerifiedPopup);